import React from 'react';
import { Divider, DividerProps } from '@chakra-ui/react';

export const DefaultScreenTileInnerDivider: React.FC<DividerProps> = ({
  ...props
}) => {
  return <Divider mx={10} {...props} />;
};
